import * as React from "react";

const FlowChartFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.3574 23.1299"{...props}>
      <g>
        <rect height={23.1299} opacity={0} width={21.3574} x={0} y={0} />
        <path d="M2.33398 8.21045L18.6621 8.21045C20.127 8.21045 20.9961 7.35107 20.9961 5.91553L20.9961 2.61475C20.9961 1.1792 20.127 0.319824 18.6621 0.319824L2.33398 0.319824C0.869141 0.319824 0 1.1792 0 2.61475L0 5.91553C0 7.35107 0.869141 8.21045 2.33398 8.21045ZM9.79492 10.5347L11.2207 10.5347L11.2207 7.44873L9.79492 7.44873ZM2.33398 17.5073L18.6621 17.5073C20.127 17.5073 20.9961 16.6479 20.9961 15.2124L20.9961 11.9116C20.9961 10.4761 20.127 9.6167 18.6621 9.6167L2.33398 9.6167C0.869141 9.6167 0 10.4761 0 11.9116L0 15.2124C0 16.6479 0.869141 17.5073 2.33398 17.5073ZM9.98047 22.8589C10.2734 23.2202 10.7617 23.2202 11.0547 22.8589L13.291 20.0952C13.7207 19.5581 13.457 18.855 12.7637 18.855L8.26172 18.855C7.54883 18.855 7.27539 19.5483 7.72461 20.0952ZM9.78516 19.5483C9.78516 19.9487 10.1074 20.2612 10.5078 20.2612C10.8984 20.2612 11.2207 19.9487 11.2207 19.5483L11.2207 16.4722L9.78516 16.4722Z" />
      </g>
    </svg>
  );
};

export default FlowChartFilled;
